import { createSelector } from "@reduxjs/toolkit";
import { openapi } from "../../openapi";
import { selectHttpCurrentUser } from "../userSelectors";

export function makeSelectRoomSyncAccess(projectNo: number) {
  const selectProjectQuery = openapi.endpoints.getMultiplacerProjectsSingleProject.select({ projectNo });
  return createSelector([selectProjectQuery, selectHttpCurrentUser], (projectQuery, user) => {
    const owners = (projectQuery.data?.members ?? []).filter((member) => member.role === "OWNER");
    return {
      owners,
      canStart: !projectQuery.isError && !!user?._id && owners.some((owner) => String(owner.userId) === String(user._id)),
    };
  });
}
